import React, { useState, useEffect } from 'react';
import { ShowCompaniesDialogComponent } from './show-companies-dialog-component';
import { CompanyBasicInfo } from '../../../../api-service/clients';
import { moduleClientFactory } from '../../../../api-service/module-client-factory';

export interface IShowCompaniesDialogProps {
  companyIds: string[];
}
export interface ICompanyBasicInfo extends CompanyBasicInfo {
  id: string;
}
export function ShowCompaniesDialog({ companyIds }: IShowCompaniesDialogProps) {
  const [isOpen, setIsOpen] = useState<boolean>(true);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [companies, setCompanies] = useState<ICompanyBasicInfo[]>([]);

  useEffect(() => {
    async function init() {
      try {
        setIsLoading(true);
        const companyClient = moduleClientFactory.createCompanyClient();
        const result = await companyClient.getCompaniesBasicInformation({ companyIds });
        setCompanies((result?.companyBasicInfos as CompanyBasicInfo[]) || []);
      } finally {
        setIsLoading(false);
      }
    }
    init();
  }, []);
  function handleClose() {
    setIsOpen(false);
  }
  return <ShowCompaniesDialogComponent isLoading={isLoading} open={isOpen} companies={companies} onClose={handleClose} />;
}
